var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: { padding: "0 10px" },
      attrs: {
        "show-close": false,
        visible: _vm.requestAgentDialogVisible,
        "before-close": _vm.handleClose,
        center: "",
        fullscreen: "",
        "custom-class": "contact-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.requestAgentDialogVisible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("div", { staticClass: "contact-title" }, [
                _vm._v("\n      Request Agent Kit\n      "),
                _c(
                  "div",
                  { staticClass: "icon", on: { click: _vm.handleClose } },
                  [_c("i", { staticClass: "el-icon-close" })]
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "requestAgentForm",
              staticStyle: { "font-family": "DINosaur-a, sans-serif" },
              attrs: {
                model: _vm.requestAgentForm,
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "100px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "First Name",
                                    prop: "firstName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      placeholder: "Your first name"
                                    },
                                    model: {
                                      value: _vm.requestAgentForm.firstName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestAgentForm,
                                          "firstName",
                                          $$v
                                        )
                                      },
                                      expression: "requestAgentForm.firstName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Last Name",
                                    prop: "lastName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      placeholder: "Your last name"
                                    },
                                    model: {
                                      value: _vm.requestAgentForm.lastName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestAgentForm,
                                          "lastName",
                                          $$v
                                        )
                                      },
                                      expression: "requestAgentForm.lastName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Company",
                                    prop: "companyName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      placeholder: "Agency/Developer name"
                                    },
                                    model: {
                                      value: _vm.requestAgentForm.companyName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestAgentForm,
                                          "companyName",
                                          $$v
                                        )
                                      },
                                      expression: "requestAgentForm.companyName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Location", prop: "state" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "popper-append-to-body": false,
                                        clearable: "",
                                        filterable: "",
                                        placeholder: "Select a state"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.validateField("state")
                                        }
                                      },
                                      model: {
                                        value: _vm.requestAgentForm.state,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.requestAgentForm,
                                            "state",
                                            $$v
                                          )
                                        },
                                        expression: "requestAgentForm.state"
                                      }
                                    },
                                    _vm._l(_vm.STATES(), function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Email", prop: "email" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      placeholder: "Your email"
                                    },
                                    model: {
                                      value: _vm.requestAgentForm.email,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestAgentForm,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "requestAgentForm.email"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Phone Number",
                                    prop: "phoneNumber"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "20",
                                      placeholder: "Your phone number"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.requestAgentForm.phoneNumber = _vm.formatPhoneNumber(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.requestAgentForm.phoneNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestAgentForm,
                                          "phoneNumber",
                                          $$v
                                        )
                                      },
                                      expression: "requestAgentForm.phoneNumber"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Message", prop: "message" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: "1000",
                                      "show-word-limit": "",
                                      placeholder: "Message"
                                    },
                                    model: {
                                      value: _vm.requestAgentForm.message,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestAgentForm,
                                          "message",
                                          $$v
                                        )
                                      },
                                      expression: "requestAgentForm.message"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "submit-button",
                                      on: {
                                        click: function($event) {
                                          return _vm.onSubmit(
                                            "requestAgentForm"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v("Confirm\n                  "),
                                      _vm.loading
                                        ? _c("i", {
                                            staticClass: "el-icon-loading"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-832418d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-832418d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/requestAgentKitDialog.vue
// module id = null
// module chunks = 